import { RecommendationStoreState } from './types';
import { defaultState } from './utils';

export class RecommendationStoreAdapter {
    getAll(): RecommendationStoreState {
        const sessionState = sessionStorage.getItem('recommendations');

        if (!sessionState) {
            return defaultState;
        }

        try {
            return JSON.parse(sessionState);
        } catch (_) {
            return defaultState;
        }
    }

    save(state: RecommendationStoreState) {
        sessionStorage.setItem('recommendations', JSON.stringify(state));
    }
}
